import { styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import withRouter from '@abs/core/withRouter';
import ABSNavBadge from '../../ABSNavBadge';
import ABSSvgIcon from '../../../ABSSvgIcon';

const StyledListItem = styled(ListItem)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none!important',
  minHeight: 48,
  '&.active': {
    backgroundColor: `${theme.palette.secondary.main}!important`,
    color: `${theme.palette.secondary.contrastText}!important`,
    pointerEvents: 'none',
    '& .abs-list-item-text-primary': {
      color: 'inherit',
    },
    '& .abs-list-item-icon': {
      color: 'inherit',
    },
  },
  '& .abs-list-item-icon': {},
  '& .abs-list-item-text': {
    padding: '0 0 0 16px',
  },
}));

function ABSNavHorizontalLink(props) {
  const { item } = props;

  return useMemo(
    () => (
      <StyledListItem
        button
        component="a"
        href={item.url}
        target={item.target ? item.target : '_blank'}
        className={clsx('abs-list-item')}
        role="button"
        sx={item.sx}
        disabled={item.disabled}
      >
        {item.icon && (
          <ABSSvgIcon
            className={clsx('abs-list-item-icon shrink-0', item.iconClass)}
            color="action"
          >
            {item.icon}
          </ABSSvgIcon>
        )}

        <ListItemText
          className="abs-list-item-text"
          primary={item.title}
          classes={{ primary: 'text-13 abs-list-item-text-primary truncate' }}
        />

        {item.badge && <ABSNavBadge className="ltr:ml-8 rtl:mr-8" badge={item.badge} />}
      </StyledListItem>
    ),
    [item.badge, item.icon, item.iconClass, item.target, item.title, item.url]
  );
}

ABSNavHorizontalLink.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
  }),
};

ABSNavHorizontalLink.defaultProps = {};

const NavHorizontalLink = withRouter(memo(ABSNavHorizontalLink));

export default NavHorizontalLink;
